/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type settlingin_ProgressIndicatorDTO = {
    indicator_id: string;
    value: settlingin_ProgressIndicatorDTO.value;
};
export namespace settlingin_ProgressIndicatorDTO {
    export enum value {
        GOOD = 'good',
        NEUTRAL = 'neutral',
        BAD = 'bad',
    }
}

